import { getTenant } from '@/stores/session'

/**
 * Turn a `$tenantSlug` path segment into the `/quotes` office filter.
 *
 * PET-2999 changed what that slug means: it used to be the tenant the session
 * was bound to, and is now the OFFICE a quote belongs to. Every path that still
 * carries one — an emailed quote link, the tenant switcher, a bookmark — lands
 * here, and the two are only the same slug for a legacy office-bound session.
 *
 * For a company session the session tenant is never one of its own readable
 * offices, so passing it through as `office` narrows the list to nothing and
 * renders "No quotes to review at this time." — indistinguishable from having
 * none. Drop the filter in that case rather than filter on an office that
 * cannot match.
 */
export function officeSearchForSlug(tenantSlug: string): { office?: string } {
  return tenantSlug === getTenant()?.slug ? {} : { office: tenantSlug }
}
